import Poster from "./Poster";
export default Poster;